import { createContext, useContext, useState } from 'react';

const CartContext = createContext();

export const useCart = () => useContext(CartContext);

export const CartProvider = ({ children }) => {
    const [cartId, setCartId] = useState(null);
    const [cartItems, setCartItems] = useState([]);
    const [showCart, setShowCart] = useState(false);

    const clearCart = () => setCartItems([]);

    const addToCart = (newItems) => {
    setCartItems((prevItems) => {
        const updatedCart = [...prevItems];

        (Array.isArray(newItems) ? newItems : [newItems]).forEach((newItem) => {
        const existingIndex = updatedCart.findIndex(
            (item) =>
                item.itemId === newItem.itemId
                // item.id === newItem.id ||
                // (item.vendorId === newItem.vendorId &&
                // item.vendorItemId === newItem.vendorItemId)
        );

        if (existingIndex > -1) {
            const previousQuantity = Number(updatedCart[existingIndex].requestedQuantity);
            const nextQuantity = Number(newItem.requestedQuantity);
            updatedCart[existingIndex] = {
                ...updatedCart[existingIndex],
                ...newItem,
                requestedQuantity:
                    (Number.isFinite(previousQuantity) ? previousQuantity : 0) +
                    (Number.isFinite(nextQuantity) ? nextQuantity : 0),
            };
        } else {
            updatedCart.push(newItem);
        }
        });

        return updatedCart;
    });
    };

    const removeFromCart = (id) => {
        setCartItems((prev) => prev.filter(item => item.itemId !== id));
    };

    const updateCartItem = (id, field, value) => {
        setCartItems((prev) =>
        prev.map(item =>
            item.itemId === id ? { ...item, [field]: value } : item
        )
        );
    };

    return (
        <CartContext.Provider
            value={{
                clearCart,
                cartItems: cartItems && cartItems?.length ? cartItems?.map((item) => ({
                    itemId: item?.itemId,
                    itemName: item?.itemName,
                    unitPrice: item?.unitPrice,
                    requestedQuantity: item?.requestedQuantity,
                })): [],
                addToCart,
                removeFromCart,
                updateCartItem,
                showCart,
                setShowCart,
                setCartId, 
                cartId
            }}>
            {children}
        </CartContext.Provider>
    );
};
